export default function (paramName) {
  if (window.location.search && window.location.search.match(`${paramName}`)) {
    return window.location.search.split(`${paramName}=`)[1].split("&")[0].replace(/\+/g, " ");
  } else {
    return false;
  }
}
